import { States } from '../../enums/States';
import { Ask } from '../Ask/ask.service';
import { FieldsTempaltesConditions } from '../FieldsTemplatesCondition/fields-tempaltes-conditions';
import { ModulesManagerService } from '../Module/modules-manager.service';
import { LoggerService } from '../../utils/logger.service';
export class Field {
    protected id = 0;
    protected templateId = 0;
    protected label: string = ""
    protected targetField: string = "none"
    protected type: string = "none"
    protected isMobile: boolean = true
    protected askId: number = 0;
    protected choices: Array<any> = [];
    protected canEdit: boolean;
    protected visible: boolean = true;
    protected size = 9999;
    protected imposed: boolean;
    protected order: number = 0;
    protected hydrated: boolean;
    protected manager: ModulesManagerService
    protected currentAsk: Ask;
    protected popup: any;
    protected _value: any;
    private timeOutUpdate: any = null

    constructor(manager: ModulesManagerService, Data = null) {
        this.manager = manager
        if (Data != null) this.Hydrate(Data)
    }

    /** 
     * use to get DivID of current field
     * @virtual
     */
    get DivId() {
        return "" + this.id
    }


    /** 
     * use to display or not the field
     * @virtual
     */
    isActive(): boolean {

        //++ hardcoded please fix that shit !!
        switch (this.targetField) {
            case "State":
                return true
            default:
                return this.visible
        }
    }

    /**
     * event fired when hydrated
     * @virtual
     */
    protected async OnHydrated() {
        await this.loadConditionsFromTemplates()
    }

    get limitSize() {
        return this.size
    }

    private pendingCondition = false
    private async loadConditionsFromTemplates() {
        if (this.pendingCondition) return;
        this.pendingCondition = true
        if (this.templateId > 0 && !this.FieldConditions.length) {

            await this.manager.GetModuleData("FieldsTemplatesConditions", 0, "FieldsTemplate", this.templateId)
        }
        this.pendingCondition = false
    }

    public HasEditRight() {
        if (!this.currentAsk.isOwner && !this.currentAsk.isTarget) return false
        if (this.hasBypassPermision) return true
        if (this.FieldConditions.length == 0) {
            switch (this.targetField) {
                case "State":
                    return !this.currentAsk?.isOwner
            }

            return true
        }
        for (const condition of this.FieldConditions)
            if (!condition.isTrue(this, this.currentAsk)) return false
        return true
    }

    /**
     * allow you to set an custom css
     * @virtual
     */
    get ValueCss() {
        return ""
    }

    get FieldConditions(): Array<FieldsTempaltesConditions> {
        return this.templateId > 0 ? this.manager.GetListModuleData("FieldsTemplatesConditions", "FieldsTemplate", this.templateId) : []
    }

    async Hydrate(Data) {
        //if(this.hydrated) return this;
        this.hydrated = false
        for (const [key, propertie] of Object.entries(Data))
            this[this.manager.Tool.minimilizeFirstChar(key)] = propertie
        await this.OnHydrated()
        this.hydrated = true
        return this
    }

    protected get value() {
        return this._value
    }

    protected set value(v: any) {
        if (this._value == v) return;
        this._value = v
        this.sendUpdate()
        this.onUpdate()
    }

    get IsMobile(): boolean {
        return this.isMobile
    }

    get Id(): number {
        return this.id
    }

    get AskId(): number {
        return this.currentAsk?.Id || this.askId
    }

    get TargetField(): string {
        return this.targetField
    }

    get CanEdit(): boolean {
        if (this.isLocked) return false
        return (this.canEdit && this.templateId > 0 || this.hasBypassPermision) && this.HasEditRight()
    }

    get Type(): string {
        return this.type
    }

    get Label(): string {
        return this.manager.Trad.Parse(this.label)
    }

    get Imposed(): boolean {
        return this.imposed
    }

    get Order(): number {
        return this.order
    }

    get Value(): any {
        switch (this.Type) {
            case "boolean":
                return this.value == "1"
            default:
                return this.value
        }

    }

    get IsImposedAndNotFilled() {
        if (!this.Imposed || !this.CanEdit || !this.isActive()) return false;
        return !this.Value?.trim()
    }

    get IsFakeAsk(): boolean {
        return this.currentAsk?.IsFake
    }

    set Value(value: any) {
        if (!this.canEdit && !this.hasBypassPermision) return;
        this.value = value
    }


    private get isLocked() {
        let lockRelation = {
            Title: ["C_Tra1", "C_Tra2", "T_Tra3"]
        }
        if (!lockRelation[this.targetField]) return false
        return lockRelation[this.targetField].map(field => this.currentAsk?.getField({ TargetField: field })).filter(Boolean).length > 0
    }

    private get UpdateRate(): number {
        let timeOut = 100
        switch (this.Type) {
            case "textarea":
            case "input":
            case "datetime":
                timeOut = 2000;
                break
            case "boolean":
            case "selector":
            case "geolocation":
                timeOut = 10;
                break
            case "document":
                timeOut = 5000;
                break
            default:
                LoggerService.warn(`Type de champ non géré: ${this.Type}`)
                break


        }
        return timeOut
    }


    get orginialValue() {
        return this.value
    }

    async exportValue() {
        return this.value
    }

    private sendUpdate() {
        if (!this.currentAsk?.IsFake && this.hydrated && this.id > 0) {
            //send update modif to server
            if (this.timeOutUpdate != null)
                clearTimeout(this.timeOutUpdate)
            this.timeOutUpdate = setTimeout(async () => {
                if (this.currentAsk)
                    this.currentAsk.Modified = true
                let resu = await this.manager.Ws.Send("Fields", "update", await this.exportData(), true).catch(e => LoggerService.error('Erreur lors de la mise à jour du champ', e))
                this.timeOutUpdate = null
            }, this.UpdateRate)

        }
    }

    get hasBypassPermision() {
        if (this.templateId > 0) return false
        if (this.currentAsk?.isTwoSideAtTime) return true
        if (this.TargetField != "State" && this.TargetField != "Report") {
            if (this.currentAsk?.IsFake || this.currentAsk?.State == States.Creating || this.currentAsk?.State == States.New && this.currentAsk?.isOwner) return true
        } else {
            // if(this.TargetField == "Report" && (this.currentAsk?.State == States.Creating  || this.currentAsk?.State == States.New)){
            //  return false
            // }
            return this.currentAsk.TargetId == this.manager.Usr.UserId
        }

        // return  (this.TargetField !=  "State" && this.TargetField !=  "Report") && (this.currentAsk?.State == States.Creating||(this.currentAsk?.State == States.New && this.currentAsk?.isOwner || this.currentAsk?.IsFake))
        return false
    }

    postTraitedValue() {
        if (this.isLocked && this.TargetField == "Title") {
            let combine = ["C_Tra1", "C_Tra2", "T_Tra3"]

            this.value = ""
            for (let field of combine) {
                let display = this.currentAsk?.displayField(field)
                if (display)
                    this.value += (this.value ? " / " : "") + display
            }
        }
        if (this.targetField == "arbo") {
            let C_Equi = this.currentAsk?.getField({ TargetField: "C_Equi" })
            if (C_Equi && C_Equi.orginialValue != 0) C_Equi.value = 0
        }
    }

    onUpdate() {

        switch (this.targetField) {
            case "C_Tra1":
            case "C_Tra2":
            case "T_Tra3":
                this.currentAsk?.getField({ TargetField: "Title" })?.postTraitedValue()
                break;
            case "arbo":
                this.postTraitedValue()
        }
    }


    async exportData() {
        return {
            Id: this.id,
            TemplateId: this.templateId,
            Label: this.label,
            TargetField: this.targetField,
            Type: this.type,
            Value: await this.exportValue(),
            CanEdit: this.canEdit,
            Size: this.size,
            Visible: this.visible,
            Imposed: this.imposed,
            Choices: this.choices,
            Order: this.order
        }
    }



    /*
        !!!!!!!!!!!!!!!VIRTUAL ZONE!!!!!!!!!!!!!!!!!!!

        (si vous connaissez pas le principe d'un override et virtuel, vous pouvez soit faire des recherches sur les virtuals et override ici https://tsdoc.org/pages/tags/override/ , 
        me demander si vraiment vous comprenez pas le principe)

        pour résumer:
        ici c'est le schéma de base des champs

        les virtuals servent à déclarer que cette fonction est une fonction virtuelle qui doit être override par le champ concret
        ce n'est que un modèle d'excution pour les champs concrets
        les champs concrets doivent override de la même manière que les virtuals sont déclarés
        les virtuals sont des fonctions qui sont appelées par le champs concret pour faire un traitement spécifique sur le champs concret

        (exemple d'utilisation dans la class GeolocationField)
    */


    /**
     * used for verifi is that field is valide for filter
     * @virtual
     * @param lookingFor string to search on field
     * @returns true if valide or false if not
     */
    public isFilterValid(lookingFor: string): boolean {
        return (this.Value + '').toLocaleLowerCase().includes(lookingFor.toLocaleLowerCase())
    }

    /** @virtual */
    async postRenderHtml(ask: Ask, args: any = {}): Promise<any> {
        this.currentAsk = ask
        if (args.popup) {
            this.popup = args["popup"]
        }
    }

    /** @virtual */
    async Destroy(): Promise<any> {
    };

    /** @virtual */
    async onClick(...args): Promise<any> {
        return null
    }

    /** @virtual */
    async onEvent(...args): Promise<any> {
        return null
    }

}
